import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Circle = styled.div`
  border: 4px solid #ccc;
  border-top: 4px solid rgba(0, 0, 0, 0);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${rotate} 1s linear infinite;
`;

const StyledBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
`;

const BackdropPanel = ({ children }) => {
  // if (!open) return null;

  return (
    <StyledBackdrop>
      <LoadingContainer>
        <Circle />
      </LoadingContainer>
      {children}
    </StyledBackdrop>
  );
};

export default BackdropPanel;
